// Accès direct (ex: http://NAS:3300) -> le backend est sur un port dédié.
// Accès via un reverse-proxy (ex: https://piscines.mon-domaine.fr) -> même
// origine, on compte sur le proxy pour router /api vers le backend.
export const API_BASE = window.location.port === '3300'
  ? `${window.location.protocol}//${window.location.hostname}:${process.env.REACT_APP_API_PORT || 5000}`
  : '';
